import { name } from "./userProfile.reducers";

export const selectSlice = (state) => state[name];

export const getAWSToken = (state) => selectSlice(state).awsToken;

export const selectIsAuthenticated = (state) =>
  selectSlice(state).isAuthenticated;

export const selectUser = (state) => selectSlice(state).user;

export const selectShouldFetchUser = (state) =>
  selectSlice(state).shouldFetchUser;
